module.exports = __webpack_public_path__ + "static/media/pop1.7cc1e4e9.jpg";